import React, { useState } from 'react';
import { T } from '../theme';

export default function LoginGate({ onLogin, authError, loading }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return;
    setSubmitting(true);
    try {
      await onLogin(email, password);
    } catch (_) {
      // Error text is surfaced from auth context.
    } finally {
      setSubmitting(false);
    }
  };

  const busy = loading || submitting;

  return (
    <div style={{ minHeight: '100vh', background: T.bg, display: 'grid', placeItems: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 420, background: T.bgCard, border: `1px solid ${T.border}`, borderRadius: 16, padding: 28 }}>
        <div style={{ marginBottom: 20, textAlign: 'center' }}>
          <div style={{ fontSize: 30, fontWeight: 800, background: `linear-gradient(135deg, ${T.cyan}, ${T.cyanLight})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            Clients Profiling
          </div>
          <div style={{ marginTop: 6, color: T.textDim, fontSize: 13 }}>Sign in to continue</div>
        </div>

        <form onSubmit={handleSubmit}>
          <label style={{ display: 'block', marginBottom: 14 }}>
            <div style={{ fontSize: 12, color: T.textDim, marginBottom: 6 }}>Email</div>
            <input
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete='email'
              required
              disabled={busy}
              style={{ width: '100%', background: T.bgInput, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: '11px 12px', outline: 'none' }}
            />
          </label>

          <label style={{ display: 'block', marginBottom: 16 }}>
            <div style={{ fontSize: 12, color: T.textDim, marginBottom: 6 }}>Password</div>
            <input
              type='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete='current-password'
              required
              disabled={busy}
              style={{ width: '100%', background: T.bgInput, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: '11px 12px', outline: 'none' }}
            />
          </label>

          {authError && (
            <div style={{ marginBottom: 14, borderRadius: 8, padding: '9px 11px', fontSize: 12, background: T.redBg, color: T.red }}>
              {authError}
            </div>
          )}

          <button
            type='submit'
            disabled={busy}
            style={{ width: '100%', border: 'none', borderRadius: 10, padding: '12px 14px', fontWeight: 700, color: '#fff', cursor: busy ? 'not-allowed' : 'pointer', opacity: busy ? 0.8 : 1, background: `linear-gradient(135deg, ${T.cyan}, ${T.cyanDark})` }}
          >
            {busy ? 'Signing in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}